import React, { Component } from 'react'
import { Loading } from '../common';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux'
import * as actionCreator from '../../redux/actions/data-action';
import history from '../../routes/history';

import { assessmentStatus } from '../../Constants';

class MainScreen extends Component {
    componentDidMount() {
        const { getAllData, setTimeout, data, dataRequest } = this.props;

        if (data && !data.sessionID) {
            setTimeout();

            getAllData(null, () => {
            if (parseInt(data.versionID) === 0) {
                sessionStorage.setItem('temp-version-id', -1);
            }
            });         
        }
    }

    componentDidUpdate() {
        const { data, dataRequest } = this.props;

        console.log(data.status);

        if (data.status == assessmentStatus.Complete)
            history.push("/Assessment/Complete");

        if (dataRequest.hasError) 
            history.push("/Error");
        
    }

    callback(result) {
        if (result) {
            history.push("/TermsAndConditions");
        }
    }

    render() {
        const { sessionID } = this.props.data;

        if (sessionID) {
          return <Redirect to={{ pathname: "/TermsAndConditions" }} />
        } else {
            return <Loading></Loading>
        }
    }
}

const mapStateToProps = (state, ownState) => ({
    data: state.data,
    dataRequest: state.dataRequest
})

export default connect(mapStateToProps, actionCreator)(MainScreen);